import { fetchOptions } from "./api";
import { getApiKey } from "./../selectors";

export const addAdditional = values => {
    return { type:"ADD_ADDITIONAL_TO_LIST", payload: values };
};

export const getAdditionalTypes = () => {
    return (dispatch, getState) => {
        return dispatch({
            type: "GET_ADDITIONAL_TYPES",
            payload: fetchOptions(getApiKey(getState()), "GetProducts?suiteId=5")
        });
    };
};

export const getAdditionalStyles = (additionalTypeId) => {
    return (dispatch, getState) =>{
        dispatch({
            type: "GET_ADDITIONAL_STYLES",
            payload: fetchOptions(getApiKey(getState()), "GetStyles?productId=" + additionalTypeId)
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/additional.js